import request from 'services/request';

export async function processDatesMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/ProcessDates/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,

    data,
  });
}
